import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "error-container"
};
const _hoisted_2 = {
  class: "error-content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[1] || (_cache[1] = _createElementVNode("span", {
    class: "icon"
  }, [_createElementVNode("i", {
    class: "fa-regular fa-4x fa-plug-circle-xmark"
  })], -1)), _cache[2] || (_cache[2] = _createElementVNode("h1", {
    class: "title"
  }, "Oops! Something went wrong", -1)), _cache[3] || (_cache[3] = _createElementVNode("h2", {
    class: "subtitle"
  }, " We couldn't load this page. Please try again later or contact support. ", -1)), _createElementVNode("button", {
    class: "retry-button",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.reloadPage && $options.reloadPage(...args))
  }, "Retry")])]);
}